module.exports = __webpack_public_path__ + "img/Management_PC_JP@3x.1b813de6.png";